import React, { useEffect } from 'react';
import { DataManager } from '../../../core/data-manager';


export default function IC_item_model_suppliers({ data, entity, setDataKeyValue }) {

    useEffect(() => {
        getSupplier();
    }, [data]);

    async function getSupplier() {
        var elIdSupplier = document.querySelector('#item_model_field_idSupplierDefault *[data-id]');
        if (elIdSupplier) {
            var res = await DataManager.getItem('supplier', parseInt(elIdSupplier.getAttribute('data-id')))
            if (res.success === 1) {
                if (data.idSupplier === "") {
                    setDataKeyValue('idSupplier', res.body[0])
                }
            }
        }

        var elIdItemModel = document.getElementById('item_model_suppliers_field_idItemModel');
        if (window.location.pathname === "/entity/item_model/edit" || window.location.pathname === "/entity/item_model/add") {
            elIdItemModel.style.display = 'none';
        } else {
            elIdItemModel.style.display = 'block';
        }
    }

    return (
        <></>
    )
};
